export default __webpack_public_path__ + "static/media/OPmax-20-Capsule-eng.dc3adc85.jpg";